import { memo } from 'react';
import styled from 'styled-components/native';

import IconReviewStar from '../../assets/svg/IconReviewStar';
import {
  coral,
  neutralDark,
  neutralLight,
  warrior,
} from '../../constants/color';
import { translate } from '../../i18n';
import formatSkuPattern from '../../utils/formatSkuPattern';
import { formatTime } from '../../utils/timestamp';

interface Props {
  nickname: string;
  score: number;
  reviewed_time: number;
  color_text: string;
  size_text: string;
}

export default function ReviewItem(props: Props) {
  const { nickname, reviewed_time, color_text, size_text, score } = props;

  return (
    <S.Box>
      <S.Row>
        <S.MainText numberOfLines={1}>{nickname}</S.MainText>
        <S.SkuText numberOfLines={1}>
          {translate('review-item-sku', {
            sku: formatSkuPattern(color_text, size_text),
          })}
        </S.SkuText>
      </S.Row>
      <S.Rating>
        <RatingStars rating={score} />
        <S.SubText>{formatTime(reviewed_time, 'YYYY-MM-DD')}</S.SubText>
      </S.Rating>
    </S.Box>
  );
}

const RatingStars = memo(({ rating }: { rating: number }) => {
  return (
    <S.Stars>
      {Array(5)
        .fill('')
        .map((_, index) => {
          const fillColor = index < rating ? coral : neutralLight;

          return (
            <S.StarBox key={index}>
              <IconReviewStar size={12} fillColor={fillColor} />
            </S.StarBox>
          );
        })}
    </S.Stars>
  );
});

const S = {
  Box: styled.View`
    background-color: ${({ theme }) => theme.palette.white};
    padding: 15px;
  `,
  Row: styled.View`
    flex-direction: row;
  `,
  MainText: styled.Text`
    color: ${warrior};
    font-size: 13px;
    line-height: 18px;
    flex: 1;
  `,
  Rating: styled.View`
    margin-top: 8px;
    flex-direction: row;
    align-items: center;
  `,
  Stars: styled.View`
    flex-direction: row;
  `,
  StarBox: styled.View`
    margin-right: 2px;
  `,
  SubText: styled.Text`
    margin-left: 16px;
    color: ${neutralDark};
    font-size: 13px;
    line-height: 18px;
  `,
  SkuText: styled.Text`
    margin-left: 16px;
    color: ${neutralDark};
    font-size: 13px;
    line-height: 18px;
    max-width: 50%;
  `,
};
